export const countryNames = {
  SE: "country.name.sweden",
  CA: "country.name.canada",
  FI: "country.name.finland",
  IN: "country.name.india",
  PT: "country.name.portugal",
  AU: "country.name.australia",
};
